<template>
    <div class="components-container">
        <div class="filter-container">
            <div>
<!--                <el-button @click="returnGradeDesign" type="gray" style="margin-left: 10px;">&nbsp;返回毕业设计管理</el-button>-->
            </div>
            <div>
                <el-select v-model="queryForm.zy" placeholder="专业" style="width: 200px" clearable>
                    <el-option v-for="(item, index) in comboOption.major" :key="item.comboValue" :label="item.comboName" :value="item.comboValue"></el-option>
                </el-select>
                <el-input v-model="queryForm.jsxm" style="width: 200px;" placeholder="教师/工号" clearable></el-input>
                <el-select v-model="queryForm.zdzt" placeholder="指导状态" style="width: 200px" clearable>
                    <el-option v-for="(item, index) in comboOption.zdzt" :key="item.comboValue" :label="item.comboName" :value="item.comboValue"></el-option>
                </el-select>

                <el-button @click="queryList" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            </div>
        </div>

        <el-table :data="tableData"  element-loading-text="数据加载中" stripe border fit highlight-current-row style="width:100%;"
            :height="500" ref="mainTable">
            <el-table-column label="序号" width="60px" align="center">
                <template slot-scope="scope">
                    <span>{{(queryForm.pageNum - 1) * queryForm.rowNum + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column label="专业" prop="zy" align="center" :formatter="zyFormatter"></el-table-column>
            <el-table-column label="工号" prop="gh" align="center" ></el-table-column>
            <el-table-column label="教师" prop="jsxm"  align="center" ></el-table-column>
            <el-table-column label="指导状态" prop="zdzt" align="center" :formatter="zdztFormatter" width="150px"></el-table-column>
            <el-table-column label="操作" align="center" width="100px">
                <template slot-scope="scope">
                    <el-button size="small" @click="editRec(scope.row);" type="warning">
                        <i class="el-icon-edit"></i>&nbsp;编辑
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="queryForm.pageNum"
                           :page-sizes="[10, 20, 50]" :page-size="queryForm.rowNum" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <!-- 新建编辑 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible"  width="800px" @closed="closeDialog" :append-to-body="true">
            <el-form class="small-space" :model="curdForm" :rules="rules" ref="curdForm" label-position="left"
                     label-width="110px" style="width: 100%;">
                <el-row style="margin-bottom:-10px;">
                    <el-col :span="12">
                        <el-form-item label="工号" prop="stuCode">{{ curdForm.gh }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="教师" prop="stuName">{{ curdForm.jsxm }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row style="margin-bottom:-10px;">
                    <el-col :span="12">
                        <el-form-item label="专业" prop="zy">
                            <el-select v-model="curdForm.zy" placeholder="专业" style="width: 220px" clearable>
                                <el-option v-for="(item, index) in comboOption.major" :key="item.comboValue" :label="item.comboName" :value="item.comboValue"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="指导状态" prop="zdzt">
                            <el-radio-group v-model="curdForm.zdzt">
                                <el-radio label="1">可选</el-radio>
                                <el-radio label="0">不可选</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item align="right">
                    <el-button type="primary" @click="save">保存</el-button>
                    <el-button @click="dialogVisible=false">取消</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>
</template>

<script>
import {globalConfig} from "../../../../static/config";
import { confirmMsg, showNotify } from "utils/message";


export default {
    name: "Instructor",
    data() {
        return {
            queryForm:{//查询
                pageNum: 1,
                rowNum: 10,
                zy:'',
                jsxm:'',
                zdzt:''
            },
            total:1,
            tableData:[],
            comboOption:{//需要显示的下拉选项
                major:null,//专业
                zdzt:null,//指导状态
            },
            dialogTitle:'',//标签的名称
            dialogVisible:false,
            curdForm:{},//弹出编辑框的数据
            saveType:'',//当前表格的状态 是保存save  还是编辑状态 edit
            rules: {
                zdzt: [{
                    required: true,
                    message: "请选择指导状态",
                    trigger: ["blur", "change"],
                }],
                zy: [{
                    required: true,
                    message: "请选择专业",
                    trigger: "change",
                }],
            },
        }
    },
    mounted() {
        this.initCombo();
        this.queryList();
    },
    methods:{
        //指导状态显示
        zdztFormatter(row){
            if (this.comboOption.zdzt == null){//防止报错
                return row.zdzt ;
            }
            for (let i = 0 ; i< this.comboOption.zdzt.length ; i++){
                if (this.comboOption.zdzt[i].comboValue == row.zdzt){
                    return this.comboOption.zdzt[i].comboName ;
                }
            }
            return row.zdzt;
        },
        //专业显示
        zyFormatter(row){
            if (this.comboOption.major == null){
                return row.zy ;
            }
            for (let i = 0 ; i< this.comboOption.major.length ; i++){
                if (this.comboOption.major[i].comboValue == row.zy){
                    return this.comboOption.major[i].comboName ;
                }
            }
            return row.zy ;
        },
        closeDialog(){
            this.dialogVisible = false;
        },
        returnGradeDesign(){
            window.location = globalConfig.FONT_PROXY_PATH+"/#/scoreManage/register/graduateDesign2"
        },
        initCombo() {
            this.$api.scoreManage.graduateDesign2.initCombo({
            }).then(response => {
                this.comboOption.major = response.data.data.major;
                this.comboOption.zdzt = response.data.data.zdzt;
            }).catch(error => {
                console.log(error);
            });
        },
        save(){
            this.$api.scoreManage.graduateDesign2.saveTeacherRec({
                data: this.curdForm,
            }).then((response) => {
                if (response.data.data == '1'){
                    showNotify('成功', '保存成功', 'success', 1500);
                }else {
                    showNotify('失败', '保存失败', 'fail', 1500);
                }
                this.dialogVisible = false ;
                this.queryList();
            }).catch((error) => {
                console.log(error);
            });
        },
        editRec(row){
            this.dialogVisible = true ;
            this.dialogTitle = "指导教师管理";
            this.saveType = 'edit';
            let rows = JSON.stringify(row);
            this.curdForm = JSON.parse(rows);
            this.curdForm.zdzt = "1";//默认指导状态为可选
        },
        handleCurrentChange(val) {
            this.queryForm.pageNum = val;
            this.queryList();
        },
        handleSizeChange(val) {
            this.queryForm.rowNum = val;
            this.queryList();
        },
        queryList(){
            this.$api.scoreManage.graduateDesign2.listTeacher({
                data: this.queryForm,
            }).then((response) => {
                this.tableData = response.data.data.list;
                for (let i = 0 ; i < this.tableData.length ; i++){
                    this.tableData[i].xmxh = this.tableData[i].xm + "/" + this.tableData[i].xh;
                }
                this.total = response.data.data.total;
            }).catch((error) => {
                console.log(error);
            });
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Instructor.vue?2f0f96d2